import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { generateSharedBlock } from "../../../Shared/components/ContentBlocks/shared_blocks";
import { VideoBlock } from "../../../Shared/components/ContentBlocks/VideoBlock/VideoBlockLayout";
import { generalContentPageBlocks } from "../../custom_api/drupal_node_conversion";
import { ButtonBlock } from "../components/button_block";
import { FaqBlock } from "../components/faq_block";
import { HighlightBlock } from "../components/highlight_block";
import { ImageBlock } from "../components/image_block";
import { RichTextBlock } from "../components/rich_text_block";
import { ActivityClusterBlock } from "./activity_cluster_block";
import { AsyncBlock } from "./async_block";
import { BooksBlock } from "./books_block";
import { CarouselContentGridBlock } from "./carousel_content_grid_block";
import { CollectionBlock } from "./collection_block";
import CollectionSearchBar from "./collection_search_bar";
import { ContentGridBlock } from "./content_grid_block";
import { FeaturedContentBlock } from "./featured_content_block";
import { FormstackBlock } from "./formstack/formstack_block";
import { GridBlock } from "./grid_block";
import { ImagesBlock } from "./images_block";
import { PanoramaBlock } from "./panorama/PanoramaWidget";
import { QuoteBlock } from "./quote_block";
import { RecentNewsBlock } from "./recentNewsBlock/recentNewsWidget";
import { SubscriptionsBlock } from "./subscriptions_block";
import { VacancyOverviewBlock } from "./vacancy_overview_block";
export const Blocks = (props)=>/*#__PURE__*/ _jsx(BlockRenderer, {
        blocks: generalContentPageBlocks(props.blocks)
    });
export class BlockRenderer extends React.Component {
    render() {
        const { blocks } = this.props;
        if (blocks.isEmpty()) return /*#__PURE__*/ _jsx(_Fragment, {});
        return /*#__PURE__*/ _jsx("div", {
            className: "blocks",
            children: blocks.map((b, i)=>/*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        generateBlock(b),
                        /*#__PURE__*/ _jsx("hr", {})
                    ]
                }, `block-${i}`))
        });
    }
    constructor(props){
        super(props);
        this.state = {};
    }
}
export const generateBlock = (b)=>b.kind == "richText" ? /*#__PURE__*/ _jsx(RichTextBlock, {
        ...b
    }) : b.kind == "image" ? /*#__PURE__*/ _jsx(ImageBlock, {
        ...b
    }) : b.kind == "video" ? /*#__PURE__*/ _jsx(VideoBlock, {
        ...b
    }) : b.kind == "faq" ? /*#__PURE__*/ _jsx(FaqBlock, {
        ...b
    }) : b.kind == "highlight" ? /*#__PURE__*/ _jsx(HighlightBlock, {
        ...b
    }) : b.kind == "images" ? /*#__PURE__*/ _jsx(ImagesBlock, {
        ...b
    }) : b.kind == "content_grid" ? /*#__PURE__*/ _jsx(ContentGridBlock, {
        ...b
    }) : b.kind == "carousel_content_grid" ? /*#__PURE__*/ _jsx(CarouselContentGridBlock, {
        ...b
    }) : b.kind == "async_block" ? /*#__PURE__*/ _jsx(AsyncBlock, {
        ...b
    }) : b.kind == "knop" ? /*#__PURE__*/ _jsx(ButtonBlock, {
        ...b
    }) : b.kind == "subscription_block" ? /*#__PURE__*/ _jsx(SubscriptionsBlock, {
        ...b
    }) : b.kind == "vacancy_overview" ? /*#__PURE__*/ _jsx(VacancyOverviewBlock, {
        ...b
    }) : b.kind == "books" ? /*#__PURE__*/ _jsx(BooksBlock, {
        ...b
    }) : b.kind == "collection" ? /*#__PURE__*/ _jsx(CollectionBlock, {
        ...b
    }) : b.kind == "featured_content" ? /*#__PURE__*/ _jsx(FeaturedContentBlock, {
        ...b
    }) : b.kind == "activity_cluster" ? /*#__PURE__*/ _jsx(ActivityClusterBlock, {
        ...b
    }) : b.kind == "quote" ? /*#__PURE__*/ _jsx(QuoteBlock, {
        ...b
    }) : b.kind == "collection_search_bar" ? /*#__PURE__*/ _jsx(CollectionSearchBar, {
        ...b
    }) : b.kind == "grid_block" ? /*#__PURE__*/ _jsx(GridBlock, {
        ...b
    }) : b.kind == "recent_news" ? /*#__PURE__*/ _jsx(RecentNewsBlock, {
        ...b
    }) : b.kind == "formstack_block" ? /*#__PURE__*/ _jsx(FormstackBlock, {
        ...b
    }) : b.kind == "panorama" ? /*#__PURE__*/ _jsx(PanoramaBlock, {
        ...b
    }) : b.kind == "empty" ? /*#__PURE__*/ _jsx(_Fragment, {}) : generateSharedBlock(b) ?? ((block)=>{
        console.warn("no renderer found for:", block);
        return /*#__PURE__*/ _jsx(_Fragment, {});
    })(b);
{}